import React from "react";
import TaskBoardLayout from "./TaskBoardLayout"; // Stelle sicher, dass der Pfad korrekt ist

function App() {
  return <TaskBoardLayout />;
}

export default App;
